import React, { useState } from "react";

import { SolutionsFrame } from "components/solutions/SolutionsFrame";
import { BlockStandard } from "components/admin/BlockStandard";
import { TextField, Typography } from "@mui/material";
import { FileUpload } from "components/MUIExtensions/FileUpload";
import { useGreenEnergyContext } from "contexts/GreenEnergyContext";
import { fetchContractLink, sendOfferData } from "api/onboarding";
import { useToken, useUserContext } from "contexts/UserContext";
import { useSetError, useErrorInfo } from "contexts/ErrorContext";
import { CustomCodes } from "contexts/ErrorContextData";

const CONTRACT_DETAILS = "contract-details";

export const ContractForm = ({ history }) => {
  const token = useToken();
  const { userProfile } = useUserContext();
  const { offerId } = useGreenEnergyContext();
  const [name, setName] = useState<string>(userProfile?.name || "");
  const [email, setEmail] = useState<string>(userProfile?.email || "");
  const [phone, setPhone] = useState<string>(userProfile?.phone || "");
  const [cpf, setCPF] = useState<string>("");
  const [address, setAdress] = useState<string>("");
  const [city, setCity] = useState<string>("");
  const [state, setState] = useState<string>("");
  const [invoice, setInvoice] = useState<FileList | null>();
  const [id, setId] = useState<FileList | null>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const errorInfo = useErrorInfo();

  const setGlobalError = useSetError();
  const hasFormError = errorInfo?.code === CustomCodes.INCOMPLETE_FORM;

  const handleSubmit = async () => {
    const isFormFilled =
      name &&
      email &&
      phone &&
      cpf &&
      address &&
      city &&
      state &&
      invoice &&
      id;
    if (isFormFilled) {
      setIsLoading(true);
      sendOfferData(
        token,
        name,
        email,
        phone,
        cpf,
        address,
        id[0],
        invoice,
        offerId
      );
      try {
        const envelopeData = await fetchContractLink(
          token,
          name,
          email,
          phone,
          cpf,
          address,
          city,
          state,
          id[0],
          offerId
        );
        history.push(CONTRACT_DETAILS, { envelopeData });
      } catch (error) {
        // @ts-expect-error
        setGlobalError(error.response?.data?.error);
        setIsLoading(false);
      }
    } else if (name === "pular") {
      history.push(CONTRACT_DETAILS);
    } else {
      setGlobalError(CustomCodes.INCOMPLETE_FORM);
    }
  };

  return (
    <SolutionsFrame
      title="Contrato de energia verde"
      buttonText="Continuar"
      onButtonClick={handleSubmit}
      isLoading={isLoading}
      currentStep={3}
      totalSteps={6}
    >
      <BlockStandard hideDivider>
        <Typography variant="h2">Inserção de dados de adesão</Typography>
        <TextField
          label="Nome"
          value={name}
          error={hasFormError && !name}
          onChange={({ target }) => {
            setName(target.value);
          }}
        />
        <TextField
          label="E-mail"
          value={email}
          error={hasFormError && !email}
          onChange={({ target }) => {
            setEmail(target.value);
          }}
        />
        <TextField
          label="Tel"
          value={phone}
          error={hasFormError && !phone}
          onChange={({ target }) => {
            setPhone(target.value);
          }}
        />
        <TextField
          label="CPF"
          value={cpf}
          error={hasFormError && !cpf}
          onChange={({ target }) => {
            setCPF(target.value);
          }}
        />
        <TextField
          label="Endereço"
          value={address}
          error={hasFormError && !address}
          onChange={({ target }) => {
            setAdress(target.value);
          }}
        />
        <TextField
          label="Cidade"
          value={city}
          error={hasFormError && !city}
          onChange={({ target }) => {
            setCity(target.value);
          }}
        />
        <TextField
          label="Estado"
          value={state}
          error={hasFormError && !state}
          onChange={({ target }) => {
            setState(target.value);
          }}
        />
        <FileUpload
          fullWidth
          fileName={invoice ? invoice[0].name : ""}
          text="Enviar a fatura de energia mais recente"
          onFileUpload={setInvoice}
          hasError={hasFormError && !invoice}
        />
        <FileUpload
          fullWidth
          fileName={id ? id[0].name : ""}
          onFileUpload={setId}
          text="Enviar documento com foto"
          hasError={hasFormError && !id}
        />
      </BlockStandard>
    </SolutionsFrame>
  );
};
